import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { useEventData } from 'data/hooks'
import { Redimer } from './redimer'

export const Award = props => {

  const gameId = useParams().gameId || playmotiv.game.gameId
  const { award, allowRedim, eventId } = props
  const { event } = award
  const awardDefinition = event.awards.find(a => a.awardId === award.awardId)
  const { refresh, rankings } = useEventData(gameId, event.eventId)


  useEffect(() => {

    if (awardDefinition.rankingId) refresh()

  }, [awardDefinition])


  return (
    <div className={`award ${award.isNew ? 'IsNew' : ''}`}>

      <div className="award-title">
        <div>{awardDefinition.title}</div>
        { !eventId && <div className="event-title">{event.title}</div>}
      </div>

      <div className="value">
        <div>
          <span className="number">{award.value}</span>
          <span className="sign">€</span>
        </div>
        { awardDefinition.rankingId &&
          <div className="position">
            <span className="number">{rankings[awardDefinition.rankingId]?.me?.position}</span>
            <span className="sign">º</span>
          </div>
        }
      </div>
      <Redimer allowRedim={allowRedim === 'true'} award={award} />
    </div>
  )
}
